export function set_answer(state, payload) {
	state.answer = payload;
}

export function set_error_message(state, message) {
	state.error_message = message;
}

export function set_is_required(state, is_required) {
	state.is_required = is_required;
}

export function set_is_displayed(state, is_displayed) {
	state.is_displayed = is_displayed;
}
